import { Component, Injector, ElementRef, ViewChild, Input, OnDestroy } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

import { CatalogEntry } from '@apps/its2/models';
import { LanguageService } from '@common/services';

import { PopupTreeviewService } from './popup-treeview.service';
import { InputBase } from '../../../base/input-base';
import { TreeModel } from '../../treeview';

@Component({
    selector: 'aa-input-treeview2',
    templateUrl: './input-treeview2.component.html',
    styleUrls: [
        './input-treeview2.component.scss',
        '../input.component.scss'
    ],
    providers: [
        PopupTreeviewService,
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: InputTreeview2Component,
            multi: true,
        }
    ],
    standalone: false
})
export class InputTreeview2Component extends InputBase<CatalogEntry> implements OnDestroy
{
    private static identifier = 0;
    @Input() treeModel: TreeModel;
    @Input() height: number;
    @ViewChild('inputZone', { static: true }) inputZone: ElementRef;
    public selectedItem: CatalogEntry = null;
    public title: string;
    public direction: 'desc' | 'asc' = 'desc';
    private destroyator = new Subject();

    constructor (
        injector: Injector,
        private popupTreeviewService: PopupTreeviewService,
        private languageService: LanguageService,
        private elementRef: ElementRef
    )
    {
        super(injector);
        this.fieldId = `input-treeview2-${InputTreeview2Component.identifier++}-id`;

        const lang = this.languageService.getShortItsmLanguage();
        this.title = `title${lang}`;
        this.popupTreeviewService.selectedItem
            .pipe(
                tap((catalogEntry: CatalogEntry) =>
                {
                    this.direction = 'desc';
                    this.value = catalogEntry;
                }),
                takeUntil(this.destroyator)
            )
            .subscribe();
        this.popupTreeviewService.clickedOutside
            .pipe(
                tap(() =>
                {
                    this.direction = 'desc';
                }),
                takeUntil(this.destroyator)
            )
            .subscribe();
    }

    ngOnDestroy (): void
    {
        this.popupTreeviewService.destroy();
    }

    public destroy ()
    {
        this.popupTreeviewService.destroy();
        this.destroyator.next(null);
        this.destroyator.complete();
    }

    onClick (): void
    {
        if (this.direction === 'desc')
        {
            const width: number = this.elementRef.nativeElement.getBoundingClientRect().width;

            this.direction = 'asc';
            this.popupTreeviewService.create(this.inputZone, this.treeModel, this.value, width, this.height);
        }
        else
        {
            this.direction = 'desc';
            this.popupTreeviewService.destroy();
        }
    }
}
